/* eslint-disable no-param-reassign */
import Fetch, { V4 } from 'Util/fetcher';

const ON_REQUEST_RESUBMIT_KYC_FORM = 'ON_REQUEST_RESUBMIT_KYC_FORM';
const ON_REQUEST_RESUBMIT_KYC_FORM_FAILURE = 'ON_REQUEST_RESUBMIT_KYC_FORM_FAILURE';
const ON_REQUEST_RESUBMIT_KYC_FORM_SUCCESS = 'ON_REQUEST_RESUBMIT_KYC_FORM_SUCCESS';

function onRequestResubmitKycForm() {
  return {
    type: ON_REQUEST_RESUBMIT_KYC_FORM,
  };
}

function onRequestResubmitKycFormSuccess(payload) {
  return {
    type: ON_REQUEST_RESUBMIT_KYC_FORM_SUCCESS,
    payload
  };
}

function onRequestResubmitKycFormFailure(payload) {
  return {
    type: ON_REQUEST_RESUBMIT_KYC_FORM_FAILURE,
    payload
  };
}

export const onDoRequestResubmitKycForm = () => (dispatch) => {
  dispatch(onRequestResubmitKycForm());
  Fetch.get(`${V4}users/me/kyc/resubmit/`).then((resp) => { 
    if (resp.ok) { 
      dispatch(onRequestResubmitKycFormSuccess(resp.json));
    } else {
      dispatch(onRequestResubmitKycFormFailure(resp.json));
    }
  }).catch((error) => {
    dispatch(onRequestResubmitKycFormFailure(error.message));
  });
};

const ON_REQUEST_RESUBMIT_KYC = 'ON_REQUEST_RESUBMIT_KYC';
const ON_REQUEST_RESUBMIT_KYC_FAILURE = 'ON_REQUEST_RESUBMIT_KYC_FAILURE';
const ON_REQUEST_RESUBMIT_KYC_SUCCESS = 'ON_REQUEST_RESUBMIT_KYC_SUCCESS';

function onRequestResubmitKyc() {
  return {
    type: ON_REQUEST_RESUBMIT_KYC,
  };
}

function onRequestResubmitKycSuccess(payload) {
  return {
    type: ON_REQUEST_RESUBMIT_KYC_SUCCESS,
    payload
  };
}

function onRequestResubmitKycFailure(payload) {
  return {
    type: ON_REQUEST_RESUBMIT_KYC_FAILURE,
    payload
  };
}

export const onDoRequestResubmitKyc = payload => (dispatch) => {
  dispatch(onRequestResubmitKyc());
  Fetch.post(`${V4}users/me/kyc/resubmit/`, payload).then((resp) => { 
    if (resp.ok) { 
      dispatch(onRequestResubmitKycSuccess(resp.json));
    } else {
      dispatch(onRequestResubmitKycFailure(resp.json));
    }
  }).catch((error) => {
    dispatch(onRequestResubmitKycFailure(error.message));
  });
};

const INITIAL_STATE = {
  resubmitKycFormLoading: false,
  resubmitKycFormData: null,
  resubmitKycFormError: null,

  resubmitKycLoading: false,
  resubmitKycData: null,
  resubmitKycError: null,
};

const kycResubmit = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_RESUBMIT_KYC_FORM:
      return {
        ...state,
        resubmitKycFormLoading: true,
        resubmitKycFormData: null,
        resubmitKycFormError: null,
      };
    case ON_REQUEST_RESUBMIT_KYC_FORM_SUCCESS:
      return {
        ...state,
        resubmitKycFormLoading: true,
        resubmitKycFormData: action.payload,
        resubmitKycFormError: null,
      };
    case ON_REQUEST_RESUBMIT_KYC_FORM_FAILURE:
      return {
        ...state,
        resubmitKycFormLoading: true,
        resubmitKycFormData: null,
        resubmitKycFormError: action.payload,
      };
  
    case ON_REQUEST_RESUBMIT_KYC:
      return {
        ...state,
        resubmitKycLoading: true,
        resubmitKycData: null,
        resubmitKycError: null,
      };
    case ON_REQUEST_RESUBMIT_KYC_SUCCESS:
      return {
        ...state,
        resubmitKycLoading: true,
        resubmitKycData: action.payload,
        resubmitKycError: null,
      };
    case ON_REQUEST_RESUBMIT_KYC_FAILURE:
      return {
        ...state,
        resubmitKycLoading: true,
        resubmitKycData: null,
        resubmitKycError: action.payload,
      };

    default:
      return state;
  }
};

export default kycResubmit;
